import { render, staticRenderFns } from "./PacksList.vue?vue&type=template&id=b94bba74&scoped=true&"
import script from "./PacksList.vue?vue&type=script&lang=js&"
export * from "./PacksList.vue?vue&type=script&lang=js&"
import style0 from "./PacksList.vue?vue&type=style&index=0&id=b94bba74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94bba74",
  null
  
)

export default component.exports